import * as yup from 'yup';
import { getMinCharactersTextMessage, getRequiredTextMessage } from '../';
export const PropertyDetailsSchema = yup.object({
  address: yup.string().min(2, getMinCharactersTextMessage('general.primary_property_address', 2)).required(getRequiredTextMessage('general.primary_property_address')),
  ownership: yup.string().min(2, getMinCharactersTextMessage('add_new_property_flow.ownership_entity', 2)).required(getRequiredTextMessage('add_new_property_flow.ownership_entity')),
  buildingSquare: yup.number().truncate().notRequired()
});
export const PropertyDetailsInitVales = {
  address: '',
  ownership: '',
  buildingSquare: ''
};